import actionTypes from '../constants/action-types';

const updatedAt = (state = null, action) => {
  if (action.type !== actionTypes.SET_UPDATED_AT) {
    return state;
  }

  return action.payload.value;
};

export default updatedAt;
